'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var table_module = require('./table.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var HeaderFootnote = function (_a) {
    var invertArrowSpace = _a.invertArrowSpace, footnote = _a.footnote;
    return footnote ? (jsxRuntime.jsxs("span", tslib.__assign({ className: cx__default.default(table_module.default['footnote-container'], 'd-flex', 'align-items-end', 'w-100', 'mt-1', 'mb-0', {
            'flex-row-reverse': invertArrowSpace
        }) }, { children: [jsxRuntime.jsx("span", tslib.__assign({ className: cx__default.default('text-start my-0', table_module.default['footnote-text']) }, { children: footnote })), jsxRuntime.jsx("span", { "data-testid": "footnote-space", className: cx__default.default('my-0', table_module.default['footnote-space']) })] }))) : null;
};
var HeaderFootnote$1 = HeaderFootnote;

exports.default = HeaderFootnote$1;
//# sourceMappingURL=HeaderFootnote.js.map
